import { FunctionComponentWithChildren } from 'src/utils/types';
import { DestructiveOperationActionHandlerContext } from './DestructiveOperationActionHandlerContext';
import { useDestructiveOperationActionHandlerProviderState } from './useDestructiveOperationActionHandlerProviderState';

export const DestructiveOperationActionHandlerProvider: FunctionComponentWithChildren = ({ children }) => {
    const { handleDestructiveOperation: handleDestructiveMutation } =
        useDestructiveOperationActionHandlerProviderState();
    return (
        <DestructiveOperationActionHandlerContext.Provider
            value={{ handleDestructiveOperation: handleDestructiveMutation }}>
            {children}
        </DestructiveOperationActionHandlerContext.Provider>
    );
};
